export default "__VITE_ASSET__B2WCR7Wh__"